const ApiGatewayConstant = {
    ASSISTANT_API_GATEWAY_PATH: '/ai/send-ai-assistant'
};

export default ApiGatewayConstant;

